import './TechDetailsComponents.css';
let TechDetailsComponents =(props) => {
    return(
        <tbody>
            <tr className='sub_tr1'>
                <td className='samestyling_td'>{props.TechCourseName}</td>  
                <td className='samestyling_td'>{props.TechTradeName}</td>
                <td className='samestyling_td'>{props.TechPassingYear}</td>
                <td className='samestyling_td'>{props.TechPercentage}</td>

               
            </tr>
            <tr className='sub_tr2'>
                    <td colSpan='4' className='xxx'>  {props.TechFromWhere}</td>
                </tr>
        </tbody>
           
        
            
        
        
        
    );
}
export default TechDetailsComponents;